import { parseCurrency } from '@helper/parseCurrency'
export const parseStoreBudgetData = (data: any[]): any[] => {
  const res = []

  for (const item of data) {
    res.push({
      'orcamento-id': item.id,
      'orcamento-ano': item.ano,
      'orcamento-empresa': item.empresaId
        ? item.empresaId + '-' + item.empresaDescricao
        : '',
      'orcamento-loja': item.lojaId
        ? item.lojaId + '-' + item.lojaDescricao
        : '',
      'orcamento-fator-venda': parseCurrency({
        value: item.fatorVendaBruta,
        country: 'pt-br'
      }),
      'orcamento-real-ano-atual': parseCurrency({
        value: item.realizadoAnoPassado,
        country: 'pt-br'
      }),
      'orcamento-previsao-orcamento': parseCurrency({
        value: item.previsaoAnoAtual,
        country: 'pt-br'
      }),
      'orcamento-crescimento-perc': parseCurrency({
        value: item.previsaoAumentoPercentual,
        country: 'pt-br'
      }),
      'orcamento-ajustado': parseCurrency({
        value: item.previsaoAjusteFino,
        country: 'pt-br'
      }),

      'orcamento-alterado': item.alterado ? item.alterado : false,
      'orcamento-crescimento-ajustado': parseCurrency({
        value: item.previsaoAumentoPercentualAjusteFino,
        country: 'pt-br'
      }),
      'orcamento-du-proj-ano-atual': parseCurrency({
        value: item.duPrevisaoAnoAtual,
        country: 'pt-br'
      }),
      'orcamento-du-previsao-orcamento': parseCurrency({
        value: item.duPrevisaoAnoAtual,
        country: 'pt-br'
      }),
      'orcamento-du-ajustado': parseCurrency({
        value: item.duPrevisaoAjusteFino,
        country: 'pt-br'
      })
    })
  }

  return res
}
